<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { useI18n } from 'vue-i18n';
import { useUserStore } from '@/stores/user-store';
import { useRuntimeBranding } from '@/composables/runtimeBranding';


const { t } = useI18n();
const userStore = useUserStore();
const { branding } = useRuntimeBranding();

const { authenticated: isAuthenticated } = storeToRefs(userStore);

const appointmentLoggedInNavItems = [
  { route: 'dashboard', i18nKey: 'dashboard' },
  { route: 'bookings', i18nKey: 'bookings' },
  { route: 'availability', i18nKey: 'availability' },
  { route: 'settings', i18nKey: 'settings' },
];
</script>

<template>
  <footer class="footer">
    <div class="footer-inner" :class="{ 'footer-inner--public': !isAuthenticated }">
      <div class="footer-brand">
        <img class="footer-logo" :src="branding.footer_logo_url" :alt="branding.logo_alt" />
        <p class="muted">{{ branding.app_title }}</p>
      </div>

      <nav v-if="isAuthenticated" class="footer-nav">
        <router-link
          v-for="navItem in appointmentLoggedInNavItems"
          :key="navItem.route"
          :to="navItem.route"
        >
          {{ t(`label.${navItem.i18nKey}`) }}
        </router-link>
      </nav>

      <div class="footer-legal" :class="{ 'footer-legal--center': !isAuthenticated }">
        <router-link to="/privacy">{{ t('label.privacyPolicy') }}</router-link>
        <router-link to="/terms">{{ t('label.legal') }}</router-link>
      </div>
    </div>
  </footer>
</template>

<style scoped>
@import '@/assets/styles/custom-media.pcss';

.footer {
  background: var(--colour-neutral-lower-dark);
  color: #f5f7fb;
  padding: 2.5rem 1.5rem;
  width: 100%;
}

.footer-inner {
  max-width: 1100px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: minmax(140px, 220px) 1fr auto;
  gap: 2rem;
  align-items: center;
}

.footer-inner--public {
  grid-template-columns: 1fr;
  justify-items: center;
  text-align: center;
  gap: 1.25rem;
}

.footer-brand {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.footer-logo {
  width: 96px;
  height: 96px;
}

.footer-nav {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem 2rem;
  font-family: metropolis;
  font-weight: 600;
  font-size: 0.8125rem;
  text-transform: uppercase;
  color: #f5f7fb;
}

.footer-nav a {
  color: inherit;
}

.footer-legal {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  font-size: 0.8125rem;
}

.footer-legal--center {
  align-items: center;
  flex-direction: row;
  gap: 1.5rem;
}

.footer-legal a {
  color: #f5f7fb;
  text-decoration: none;
}

.muted {
  color: rgba(245, 247, 251, 0.7);
  font-size: 0.75rem;
}

@media (max-width: 960px) {
  .footer-inner {
    grid-template-columns: 1fr;
    align-items: start;
  }

  .footer-legal {
    flex-direction: row;
    flex-wrap: wrap;
  }
}
</style>
